import React from "react";
import { Header } from "../../organism/Header/Header";
import { Footer } from "../../organism/Footer/Footer";
import { Carousel } from "../../organism/Carousel/Carousel";
import { getCandidateConfig } from "../../../../config/candidates";

interface GeneralLayoutProps {
  children: React.ReactNode;
}

export const GeneralLayout: React.FC<GeneralLayoutProps> = ({
  children,
}) => {
  const config = getCandidateConfig();
  const carouselImages = config.carouselImages || [];

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      
      <div className="container mx-auto flex flex-col items-center justify-center p-4 pt-24 lg:flex-row lg:gap-8">
        {/* Main Content */}
        <main className="flex-grow w-full lg:w-2/3 flex flex-col items-center justify-center">
            {children}
        </main>

        {/* Sidebar / Carousel */}
        {carouselImages.length > 0 && (
            <aside className="w-full lg:w-1/3 mt-8 lg:mt-0 flex flex-col gap-4">
                <Carousel images={carouselImages} />
                {config.websiteUrl && (
                     <div className="flex justify-center items-center mt-2">
                         <a 
                            href={config.websiteUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="border border-gray-400 text-gray-500 bg-transparent py-2 px-4 rounded-md text-sm font-medium text-center hover:border-tertiary hover:text-tertiary transition-colors"
                        >
                            Visitar Sitio Web Oficial
                        </a>
                     </div>
                )}
            </aside>
        )}
      </div>

      <Footer />
    </div>
  );
};
